import React from 'react';
import StatusList from '../components/StatusManagement/StatusList';

const StatusManagement = () => {
  return (
    <div className="bg-light-bg-secondary dark:bg-dark-bg-primary">
      <title>Statuses | Talent Service</title>
      <StatusList />
    </div>
  );
};

export default StatusManagement;
